<template>
    <div>
        <div class="title whiteBox">{{ $t('view.授权委托书管理') }}</div>
        <div style="background: #fff;padding: 20px; margin-bottom: 20px;">
            <el-button v-if="!has1And3(tableData)" size="mini" type="primary" style="margin-bottom: 20px;" @click="det('','add')">{{ $t('view.变更授权委托书') }}</el-button>
            <!-- 表格数据 -->
            <el-table header-row-class-name="tableHeader" :data="tableData" style="width: 1010px;" border>
                <el-table-column align="center" type="index" width="60"  show-overflow-tooltip :label="$t('view.序号')"></el-table-column>
                <el-table-column prop="sectionName" show-overflow-tooltip width="360" :label="$t('view.投标授权委托书')">
                     <template slot-scope="scope">
                        <File v-if="scope.row.authorizationFileList" :clsoe="false"  :file="scope.row.authorizationFileList[0]"></File>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="organizationName" width="200" show-overflow-tooltip :label="$t('view.委托书有效期 ')">
                    <template slot-scope="scope">
                        {{ scope.row.authorizationStart }}-{{ scope.row.authorizationEnd }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="bpmNameStr" width="150" show-overflow-tooltip :label="$t('view.招标联系人')"></el-table-column>
                <el-table-column align="center" prop="date" width="100" show-overflow-tooltip :label="$t('view.状态')">
                    <template slot-scope="scope">
                        {{getStatus('authorization_book_status',scope.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="createTime" width="120" show-overflow-tooltip :label="$t('view.提交时间')">
                     <template slot-scope="scope">
                        {{parseTime(scope.row.createTime,'{y}-{m}-{d}')}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="materialName" width="120" show-overflow-tooltip :label="$t('view.审批通过时间')">
                     <template slot-scope="scope">
                        {{parseTime(scope.row.completeTime,'{y}-{m}-{d}')}}
                    </template>
                </el-table-column>
            </el-table>
            <!-- </div> -->
        </div>
        <PowerOfAttorney ref="PowerOfAttorney"></PowerOfAttorney>
    </div>
  </template>
    
<script>
import {getDicts} from '@/api/index'
import {webBookList,warningTime} from '@/api/index'
import File from '@/components/file.vue'
import PowerOfAttorney from '@/components/PowerOfAttorney.vue'
  export default {
    components:{File,PowerOfAttorney},
    data(){
        return{
            tableData:[],
            total:0,
            authorization_book_status:[],
            value:'',
            locale: localStorage.getItem('locale')||'zh',
            form:{
                pageNum:1,
                createByName:'',
                companyName:'',
                sectionName:'',
                status:'',
                pageSize:1000
            }
        }
    },
    created(){
        this.getDicts('authorization_book_status')
        this.webBookList()
    },
    methods:{
        has1And3(arr) {
            // 非数组直接返回false
            if (!Array.isArray(arr)) return false;
            return arr.some(item => item.status == 1 || item.status == 3);
        },
        det(id,type){
            if(type=='add'){
                warningTime().then(res=>{
                    this.$refs.PowerOfAttorney.show({status:res.data.authorizationBook.status,authorizationFileList:[]}, 'notExpired')
                })
            }
        },
        // 字典项
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
           // 重新上传
        reuploadClick(list){
            this.$set(this.form,list,[])
            this.$forceUpdate()
        },
        // 详情
        questionGet(id,type){
            this.$router.push({
                path:'SparePartsDet',
                query:{id:id,type:type}
            })
        },
        // 重置
        resetting(){
            this.form={
                pageNum:1,
                createByName:'',
                companyName:'',
                sectionName:'',
                status:'',
                pageSize:10
            }
            this.TimeList=[]
            this.webBookList()
        },
        handleCurrentChange(e){
            this.form.pageNum=e
            this.webBookList()
        },
        webBookList(){
            webBookList(this.form).then(res=>{
                this.total=res.total
                this.tableData=res.rows
            })
        },  
    }
};
</script>
<style lang="scss" scoped>  
    .whiteBox span{
        color: #333333;
        font-size: 14px;
    }
    .whiteBox div{width:  30%;}
    .title{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
    }
</style>
   